import { TextField as MuiTextField } from "@material-ui/core";
import React, { FC } from "react";
import styled from "@emotion/styled";
import {Autocomplete as MuiAutocomplete} from "@mui/material";
import {useTranslation} from "react-i18next";

const Autocomplete = styled(MuiAutocomplete)`
  .MuiFormControl-root {
    height: 100%
  }
`

const TextField = styled(MuiTextField)`
  background: #233145;
  & .MuiOutlinedInput-root {
    border-radius: 8px;
  },
  & .MuiInputBase-input {
    padding: 13.5px 13px;
    min-width: 33px;
    text-align: left;
  },
  & .MuiInputBase-root {
    height: 100%;
  },
  & .MuiInputLabel-outlined {
    top: -5px;
  },
  & .MuiInputLabel-shrink {
    top: 0 !important;
  },
  .MuiOutlinedInput-adornedEnd {
    padding: 0
  },
  & .MuiAutocomplete-clearIndicator {
    color: #ffffff7d
  },
  & .MuiAutocomplete-popupIndicator {
    color: #ffffff7d
  },
  .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 4px 7.5px 13px;
  },
`

type PropsType = {
  selected: any,
  setSelected: (id: string) => void,
  list: {name: string, id: string, is_live_user: boolean}[]
}

const SelectCompany: FC<PropsType> = ({selected, setSelected, list}) => {
  const { t } = useTranslation()
  return (
    <Autocomplete
      options={list.filter((i) => i.is_live_user)}
      getOptionLabel={(option: any) => option.name || ""}
      isOptionEqualToValue={(option: any, value) => option.id === value}
      onChange={(e, value: any) => {
        if (value) {
          setSelected(value.id);
        }
      }}
      onInputChange={(e, newInputValue, reason) => {
        if (reason === "clear") {
          setSelected("");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("signupForm_signUp_companyLabel")}
          variant="outlined"
          fullWidth
        />
      )}
      fullWidth
    />
  );
}

export default SelectCompany
